import React, { useState } from "react";
import { Modal, Form, Input, Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { uploadMysteryData } from "../../apis";

function UploadData({ visible, onCancel, onSuccess }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);

  const handleUpload = async () => {
    try {
      const values = await form.validateFields();

      if (fileList.length === 0) {
        message.error("Please select a file");
        return;
      }

      const formData = new FormData();
      formData.append("version", values.version);
      formData.append("file", fileList[0]);

      setLoading(true);
      await uploadMysteryData(formData);

      message.success("Upload successful!");
      form.resetFields();
      setFileList([]);
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error(err);
      message.error("Upload failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      visible={visible}
      title="Upload Mystery Data"
      onCancel={onCancel}
      onOk={handleUpload}
      confirmLoading={loading}
      okText="Upload"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Version Name"
          name="version"
          rules={[{ required: true, message: "Please input the version name" }]}
        >
          <Input placeholder="e.g., v0" />
        </Form.Item>

        <Form.Item
          label="File"
          name="file"
          rules={[{ required: true, message: "Please select a file" }]}
        >
          <Upload
            beforeUpload={(file) => {
              setFileList([file]); // Keep only one file
              return false; // prevent auto-upload
            }}
            onRemove={() => setFileList([])}
            fileList={fileList}
            maxCount={1}
          >
            <Button icon={<UploadOutlined />}>Select File</Button>
          </Upload>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default UploadData;
